<ul #containerElement class="list-group feature_list_container" style="min-height: 50px;">
    <li #listItem class="list-group-item" *ngFor="let feature of featureList()">
        <h4 *ngIf="feature.Title">{{ feature.Title }}</h4>
        <h4 *ngIf="!feature.Title">{{ feature.PartnerPricingToolFeature.Title }}</h4>
        <p *ngIf="feature.Definition">{{ feature.Definition }}</p>
        <p *ngIf="!feature.Definition">{{ feature.PartnerPricingToolFeature.Definition }}</p>
    </li>
</ul>